import React from 'react';
import { Helmet } from 'react-helmet';
import { InlineShareButtons } from 'sharethis-reactjs';

function SocialShareIcons({ shareUrl, title, description, image }) {

  const handleShareClick = (event, network) => {
    console.log('network value is', network, shareUrl)
    event.stopPropagation(); // Prevent the outer function from being triggered
    if (network === 'linkedin') {
      // Custom LinkedIn share URL
      const linkedInUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`;
      window.open(linkedInUrl, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div onClick={handleShareClick}>
      <Helmet>
        <meta property="og:url" content={shareUrl} />
        <meta property="og:type" content="article" />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content={image} />
      </Helmet>
      <InlineShareButtons
        config={{
          alignment: 'center',  // Alignment of buttons (left, center, right)
          color: 'social',      // Set the color of buttons (social, white)
          enabled: true,        // Enable buttons
          font_size: 16,        // Font size
          labels: 'cta',        // Button labels (cta, counts, none)
          language: 'en',       // Language
          networks: [           // Social networks to include
            'facebook',
            'twitter',
            'whatsapp',
            'linkedin',         // Replaced 'email' with 'linkedin'
            'copy'
          ],
          padding: 12,          // Padding between buttons
          radius: 4,            // Button corner radius
          show_total: false,    // Show the total number of shares
          size: 20,             // Button size
          url: shareUrl,        // URL to share
          title: title,         // Title to be shared
          description: 'Bodyshopguru', // Description to be shared
          onClick: handleShareClick,
        }}
      />
    </div>
  );
}

export default SocialShareIcons;
